'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./dist/react-hot-loader.production.min.js');
} else {
  module.exports = require('./dist/react-hot-loader.development.js');
}



//////////////////
// WEBPACK FOOTER
// ./~/react-hot-loader/patch.js
// module id = 294
// module chunks = 0